const CoverFeeType = Object.freeze({
  Standard: 0,
  TimeSlot: 1
})

const CoverFeeStatus = Object.freeze({
  Inactive: 0,
  Active: 1,
  Upcoming: 2
})

export function getCoverFeeTypeName (type) {
  return (type === CoverFeeType.Standard) ? 'standard' : 'timeslot'
}

export {
  CoverFeeType,
  CoverFeeStatus
}
